var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDoenOrderId(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.36066 5.62351C3.3278 5.5915 3.18726 5.4706 3.07166 5.35799C2.34463 4.69779 1.15463 2.97551 0.791396 2.07407C0.733029 1.93718 0.609496 1.59106 0.601562 1.40614C0.601562 1.22894 0.642362 1.06003 0.725096 0.898841C0.840696 0.697908 1.0226 0.536721 1.23736 0.448399C1.3864 0.391542 1.83236 0.30322 1.8403 0.30322C2.3282 0.214898 3.12096 0.166321 3.99703 0.166321C4.83173 0.166321 5.5922 0.214898 6.08746 0.287211C6.0954 0.295492 6.6496 0.383814 6.83943 0.480416C7.18623 0.657612 7.40156 1.00372 7.40156 1.37412V1.40614C7.39306 1.64737 7.17773 2.15467 7.1698 2.15467C6.806 3.00753 5.67436 4.69006 4.9224 5.36627C4.9224 5.36627 4.72916 5.55672 4.60846 5.63952C4.43506 5.76869 4.2203 5.83272 4.00553 5.83272C3.76583 5.83272 3.54256 5.76041 3.36066 5.62351Z",
    fill: "#1080FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDoenOrderId);
export default __webpack_public_path__ + "static/media/arrowDoenOrderId.56f376fd4b622b1b96cbcbcaf0ae27df.svg";
export { ForwardRef as ReactComponent };